/**
 * Payroll periods and reverts. Mounted under /hr.
 *
 * The period list lives at periods-revert rather than periods: the existing
 * /hr/payrollmanagement/periods route belongs to the payroll-run screens and is
 * a different view of the same table.
 */
export const payrollRevertRoutes: any[] = [
  {
    path: 'payrollmanagement/periods-revert',
    name: 'payrollPeriodsRevert',
    component: () => import('@/modules/hr/payrollmanagement/revert/components/PayrollPeriodList.vue'),
    meta: { title: 'routes.payrollPeriodsRevert', requiresAuth: true, breadcrumb: 'Payroll Periods' },
  },
  {
    path: 'payrollmanagement/revert-requests',
    name: 'payrollRevertRequests',
    component: () => import('@/modules/hr/payrollmanagement/revert/components/RevertRequestList.vue'),
    meta: { title: 'routes.payrollRevertRequests', requiresAuth: true, breadcrumb: 'Revert Requests' },
  },
]

export default payrollRevertRoutes
